import { KeyRound, Landmark, Laptop, PenLine, Smartphone, type LucideIcon } from 'lucide-react'

export type Supply = {
  icon: LucideIcon
  label: string
  detail?: string
}

export const supplies: Supply[] = [
  { icon: Laptop, label: 'A computer with internet' },
  { icon: Smartphone, label: 'Your smartphone' },
  { icon: KeyRound, label: 'The Leslie Outreach Stripe password' },
  {
    icon: Landmark,
    label: 'Bank routing number and account number',
    detail: "From a check or the bank's website",
  },
  { icon: PenLine, label: 'A pen and paper' },
]
